import AgentActivity from 'models/agent_activity';
import changeCurrentLocation from 'actions/lib/change_current_location';
import EditableUser from 'models/editable_user';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';
import UserEditor from 'models/location/user_editor';

export default class OpenNewUser {
  constructor(context) {
    this.context = context;
  }

  run() {
    if (!this.context.stores.appFeatures.get().isEnabled('userManagement')) {
      this.context.router.navigateHome();
      return;
    }

    this.updateCurrentLocation();
    this.setUserEditor();

    this.context.executeAction(SetAndLogActivity, { type: AgentActivity.Type.USERS_ADMIN });
  }

  updateCurrentLocation() {
    changeCurrentLocation(this.context, UserEditor.create());
  }

  setUserEditor() {
    let editableUser = EditableUser.create();
    this.context.stores.userEditor.set(editableUser);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/users/open_new_user.js